// extracted by mini-css-extract-plugin
export var indeterminate = "_26-6";
export var md = "_26-5";
export var semantic = "_26-7";
export var sm = "_26-4";
export var text = "_26-8";
export var toggleControl = "_26-0";
export var toggleInput = "_26-1";
export var toggleSwitch = "_26-2";
export var xs = "_26-3";